// extracted by mini-css-extract-plugin
module.exports = {"container":"Project_container__3R4RZ","heading":"Project_heading__2N39z","aligner":"Project_aligner__5wR1f"};